<mat-accordion>
  <mat-expansion-panel [(expanded)]="isExpanded">
    <mat-expansion-panel-header>
      <mat-panel-title>Participants</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="col-md-12">
      <div class="row">
        @if (!editMode && permissions._edit) {
          <div class="col-md-2">
            <button mat-raised-button class="edit-button" (click)="toggleEdit()">EDIT</button>
          </div>
        }
        @if (editMode && permissions._edit) {
          <div class="col-md-2">
            <button mat-raised-button class="save-button" (click)="updateParticipants()">SAVE</button>
            <button mat-raised-button class="edit-button" (click)="toggleEdit()">Cancel</button>
          </div>
        }
      </div>
      <div class="row align-top gutters">
        @for (table of participants | keyvalue; track table) {
          <div class="col-md-6 mat-elevation-z4">
            <div class="subsection-header {{table.value.color}}">
              {{table.value.title}}
            </div>
            @if (!editMode) {
              <div>
                <table mat-table class="stripped-table" [dataSource]="getDataSource(table.key)" matSort>
                  <ng-container matColumnDef="role">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Role</th>
                    <td mat-cell class="name-column" *matCellDef="let row">{{row.role}}</td>
                  </ng-container>
                  <ng-container matColumnDef="participant">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Participant</th>
                    <td mat-cell *matCellDef="let row"><a class='data-link' href="{{row.url}}" target="_blank">{{row.participant}}</a></td>
                  </ng-container>
                  @if (table.key==='ThirdPartyParticipants') {
                    <ng-container matColumnDef="sponsor">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Sponsor</th>
                      <td mat-cell *matCellDef="let row">
                        @if (row.sponsorurl===null) {
                          <span>{{row.sponsor}}</span>
                        }
                        @if (row.sponsorurl!==null) {
                          <a class='data-link' href="{{row.sponsorurl}}" target="_blank">{{row.sponsor}}</a>
                        }
                      </td>
                    </ng-container>
                  }
                  <tr mat-header-row *matHeaderRowDef="table.value.columns"></tr>
                  <tr mat-row *matRowDef="let row; columns: table.value.columns"></tr>
                </table>
              </div>
            }
            @if (editMode) {
              <div>
                @for (form of forms[table.key]; track form; let k = $index) {
                  <form [formGroup]="form">
                    @if (editMode) {
                      <table mat-table class="stripped-table" #creaTable
                        #creaSort="matSort" [dataSource]="[form]" matSort>
                        <!-- Role Column -->
                        <ng-container matColumnDef="role">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
                          <td mat-cell class="name-column" *matCellDef="let row; let i = index" style="vertical-align: top"> {{row.value.role}}
                            <ng-container>
                              <button mat-mini-fab class="attribute-buttons" class="action-button" (click)="addEditRow(row)" style="font-size: 16px">
                                <mat-icon>add</mat-icon>
                              </button>
                            </ng-container>
                          </td>
                        </ng-container>
                        <!-- Participant Column -->
                        <ng-container matColumnDef="participant">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header> Participant </th>
                          <td mat-cell *matCellDef="let row; let i = index">
                            <ng-container>
                              @for (part of row.controls.data.controls; track part; let j = $index) {
                                <div>
                                  <mat-form-field class="full-width">
                                    <input matInput [formControl]="part.controls.participant"
                                      [matAutocomplete]="searchauto" (focus)="searchParticipant(part, j, $event, table.key)">
                                  </mat-form-field>
                                  <mat-autocomplete #searchauto="matAutocomplete" [displayWith]="displayVal">
                                    @for (val of searchResults; track val) {
                                      <mat-option
                                        [value]="val"
                                        >
                                        {{val.name}}
                                      </mat-option>
                                    }
                                  </mat-autocomplete>
                                  <button mat-mini-fab (click)="deleteParticipant(part, form, j, table.key)" class="action-button" style="font-size: 16px">
                                    <mat-icon>close</mat-icon>
                                  </button>
                                </div>
                              }
                            </ng-container>
                          </td>
                        </ng-container>
                        @if (k == 0) {
                          <tr mat-header-row *matHeaderRowDef="editColumns"></tr>
                        }
                        <tr mat-row *matRowDef="let row; columns: editColumns;"></tr>
                      </table>
                    }
                    <!--                  <table mat-table class="stripped-table" [dataSource]="getControlSource(table.key)">-->
                    <!--                    <ng-container matColumnDef="role">-->
                    <!--                      <th mat-header-cell *matHeaderCellDef>Role</th>-->
                    <!--                      <td mat-cell class="name-column" *matCellDef="let row" [formGroup]="row">-->
                    <!--                        <mat-form-field>-->
                    <!--                          <mat-select *ngIf="table.key == 'CREAParticipants'" [formControl]="row.controls.role" [placeholder]="row.controls.role.value ?? 'Role'">-->
                    <!--                            <mat-option *ngFor="let role of CREARoles" [value]="role">{{role.name}}</mat-option>-->
                  <!--                          </mat-select>-->
                  <!--                          <mat-select *ngIf="table.key == 'ThirdPartyParticipants'" [formControl]="row.controls.role" [placeholder]="row.controls.role.value">-->
                  <!--                            <mat-option *ngFor="let role of thirdPartyRoles" [value]="role">{{role.name}}</mat-option>-->
                <!--                          </mat-select>-->
              <!--                        </mat-form-field>-->
            <!--                      </td>-->
          <!--                    </ng-container>-->
          <!--                    <ng-container matColumnDef="participant">-->
          <!--                      <th mat-header-cell *matHeaderCellDef>Participant</th>-->
          <!--                      <td mat-cell *matCellDef="let row" [formGroup]="row">-->
          <!--                        <mat-form-field>-->
          <!--                          <mat-label>Participant</mat-label>-->
          <!--                          <input matInput name="participant" type="text" [matAutocomplete]="searchauto" (focus)="searchParticipant(row)" [formControl]="row.controls.participant">-->
        <!--                        </mat-form-field>-->
        <!--                        <mat-autocomplete #searchauto="matAutocomplete" [displayWith]="displayVal">-->
        <!--                          <mat-option-->
        <!--                            *ngFor="let val of searchResults"-->
        <!--                            [value]="val"-->
        <!--                          >-->
        <!--                            {{val.name}}-->
      <!--                          </mat-option>-->
    <!--                        </mat-autocomplete>-->
  <!--                      </td>-->
<!--                    </ng-container>-->
<!--                    <ng-container matColumnDef="actions">-->
<!--                      <th mat-header-cell *matHeaderCellDef></th>-->
<!--                      <td mat-cell *matCellDef="let row">-->
<!--                        <button mat-mini-fab class="action-button" (click)="updateParticipant(row)"><i class="material-icons" style="font-size: 16px">save</i></button>-->
<!--                        <button mat-mini-fab class="action-button" (click)="deleteParticipant(row)" *ngIf="row.value.id"><i class="material-icons" style="font-size: 16px">delete</i></button>-->
<!--                        <button mat-mini-fab class="action-button" (click)="removeRow(table.key)" *ngIf="!row.value.id"><i class="material-icons" style="font-size: 16px">close</i></button>-->
<!--                      </td>-->
<!--                    </ng-container>-->
<!--                    <tr mat-header-row *matHeaderRowDef="editColumns"></tr>-->
<!--                    <tr mat-row *matRowDef="let row; columns: editColumns"></tr>-->
<!--                  </table>-->
</form>
}
</div>
}
</div>
}
</div>
</div>
</mat-expansion-panel>
</mat-accordion>
